import {atom} from 'jotai';

export const currentProductDetailIdAtom = atom<number>(0);
